import { Component, ViewEncapsulation } from '@angular/core';
import { DashboardHeaderComponent } from '../dashboard-header/dashboard-header.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'lv-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [DashboardHeaderComponent, RouterOutlet]
})
export class DashboardComponent {}
